import styled from 'styled-components';

import { theme } from 'coreOld/themes';

export const textFieldStyle = {
  border: `1px solid ${theme.palette.neutral.light}`,
};

export const Wrapper = styled.div`
  height: 45px;
`;
